/*eslint no-restricted-imports: ["error", { "patterns": ["*"] }]*/
/**
 * Why the rule above?
 * We need this file to stay as static as possible. If we start importing functions that generate booleans or values,
 * it will become difficult to keep track of the real values assigned to the configuration.
 * If you need dynamic behaviour, please do it wherever you're using the feature flag hooks.
 */

// eslint-disable-next-line no-restricted-imports
import { FeatureToggleConfig } from './src/types';

export const config = {
  // Here as a default / example
  'my-feature-flag': {
    defaultValue: false,
    variants: ['control', 'variation-1'],
    experiment: {
      key: 'test-experiment',
      isSSR: true,
      pathnames: ['/ab-tests-pages', '/ab-tests-app'],
    },
  },
  'radar-promo-modal': {
    defaultValue: false,
  },
  // Now on for everyone (the hub is the default home). Kept as a plain flag so the classic home stays
  // reachable as a kill-switch via `?feature-flags=home-hub-redesign:false`.
  'home-hub-redesign': {
    defaultValue: true,
  },
  'agency-projects-page': {
    defaultValue: false,
    enabledForEnvironments: ['development'],
  },
} as const satisfies Record<string, FeatureToggleConfig>;
